import { useTranslation } from 'react-i18next';
import FeedbackListItem from './FeedbackListItem';

const FeedbackList = ({ suggestions, remainingUpvotes, maxUpvotes, canWrite, pendingUpvotes, onUpvote }) => {
    const { t } = useTranslation();

    if (!suggestions || suggestions.length === 0) {
        return <p className="text-secondary m-0">{t('feedback.empty')}</p>;
    }

    return (
        <div className="d-flex flex-column">
            {suggestions.map((suggestion, index) => (
                <FeedbackListItem
                    key={suggestion.id}
                    suggestion={suggestion}
                    remainingUpvotes={remainingUpvotes}
                    maxUpvotes={maxUpvotes}
                    canWrite={canWrite}
                    pending={pendingUpvotes.includes(suggestion.id)}
                    withDivider={index > 0}
                    onUpvote={() => onUpvote(suggestion.id)}
                />
            ))}
        </div>
    );
};

export default FeedbackList;
